import { motion } from "framer-motion";
import { ArrowRight, Music } from "lucide-react";
import { FINAL } from "../../data/homeContent";
import { useAudio } from "../../context/AudioContext";
import { FEATURED_TRACK_IDS } from "../../data/tracks";

const scrollTo = (href) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const QuizBand = ({ onFind }) => {
  const { playTrack } = useAudio();

  const experienceMusic = () => {
    scrollTo("#experience");
    setTimeout(() => playTrack(FEATURED_TRACK_IDS[0]), 400);
  };

  return (
    <section id="quiz" data-testid="quiz-band" className="relative py-28 md:py-40 overflow-hidden grain">
      <div className="aurora-weave" />
      <div className="line-weave" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[55rem] h-[55rem] radial-glow blur-3xl pointer-events-none" />

      <div className="relative z-10 max-w-3xl mx-auto px-5 md:px-8 text-center">
        <motion.p initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          className="text-sm tracking-[0.24em] uppercase text-[#E7CC86]/80 mb-5">{FINAL.eyebrow}</motion.p>
        <motion.h2 initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.1 }}
          className="font-display font-semibold text-4xl sm:text-5xl lg:text-6xl leading-[1.08] text-cream mb-6">
          {FINAL.h} <span className="text-gold">{FINAL.hGold}</span>
        </motion.h2>
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.25 }}
          className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
          <button data-testid="quiz-band-cta" onClick={() => onFind?.()}
            className="btn-gold px-9 py-4 rounded-full text-lg font-semibold inline-flex items-center justify-center gap-3">
            {FINAL.primaryCta} <ArrowRight size={22} />
          </button>
          <button data-testid="experience-music-cta" onClick={experienceMusic}
            className="btn-ghost-gold px-9 py-4 rounded-full text-lg font-medium inline-flex items-center justify-center gap-3">
            <Music size={20} className="text-[#E7CC86]" /> {FINAL.secondaryCta}
          </button>
        </motion.div>
      </div>
    </section>
  );
};
